import { render } from "./NavSwiper.vue?vue&type=template&id=75145169&scoped=true"
import script from "./NavSwiper.vue?vue&type=script&lang=js"
export * from "./NavSwiper.vue?vue&type=script&lang=js"

import "./NavSwiper.vue?vue&type=style&index=0&id=75145169&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75145169"]])

export default __exports__